/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getNutritionPlanIPS } from 'app/entities/nutrition-plan-ip/nutrition-plan-ip.reducer';
import { getEntities as getTreatmentPlans } from 'app/entities/treatment-plan/treatment-plan.reducer';
import { getEntities as getNutritionOrders } from 'app/entities/nutrition-order/nutrition-order.reducer';
import { MealStatus } from 'app/shared/model/enumerations/meal-status.model';
import { createEntity, getEntity, reset, updateEntity } from './meal-plan.reducer';

export const MealPlanUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const nutritionPlanIPS = useAppSelector(state => state.nutritionPlanIP.entities);
  const treatmentPlans = useAppSelector(state => state.treatmentPlan.entities);
  const nutritionOrders = useAppSelector(state => state.nutritionOrder.entities);
  const mealPlanEntity = useAppSelector(state => state.mealPlan.entity);
  const loading = useAppSelector(state => state.mealPlan.loading);
  const updating = useAppSelector(state => state.mealPlan.updating);
  const updateSuccess = useAppSelector(state => state.mealPlan.updateSuccess);
  const mealStatusValues = Object.keys(MealStatus);

  const handleClose = () => {
    navigate(`/meal-plan${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getNutritionPlanIPS({}));
    dispatch(getTreatmentPlans({}));
    dispatch(getNutritionOrders({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.plannedAt !== undefined && typeof values.plannedAt !== 'number') {
      values.plannedAt = Number(values.plannedAt);
    }
    if (values.delveredAt !== undefined && typeof values.delveredAt !== 'number') {
      values.delveredAt = Number(values.delveredAt);
    }
    if (values.consumedAt !== undefined && typeof values.consumedAt !== 'number') {
      values.consumedAt = Number(values.consumedAt);
    }

    const entity = {
      ...mealPlanEntity,
      ...values,
      nutritionPlan: nutritionPlanIPS.find(it => it.id.toString() === values.nutritionPlan?.toString()),
      treatmentPlan: treatmentPlans.find(it => it.id.toString() === values.treatmentPlan?.toString()),
      nutritionOrder: nutritionOrders.find(it => it.id.toString() === values.nutritionOrder?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          status: 'PLANNED',
          ...mealPlanEntity,
          nutritionPlan: mealPlanEntity?.nutritionPlan?.id,
          treatmentPlan: mealPlanEntity?.treatmentPlan?.id,
          nutritionOrder: mealPlanEntity?.nutritionOrder?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.mealPlan.home.createOrEditLabel" data-cy="MealPlanCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.mealPlan.home.createOrEditLabel">Create or edit a MealPlan</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="meal-plan-id"
                  label={translate('tinyMedicRestApp.mealPlan.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.mealPlan.active')}
                id="meal-plan-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mealPlan.cursor')}
                id="meal-plan-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mealPlan.lastupdated')}
                id="meal-plan-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mealPlan.plannedAt')}
                id="meal-plan-plannedAt"
                name="plannedAt"
                data-cy="plannedAt"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mealPlan.delveredAt')}
                id="meal-plan-delveredAt"
                name="delveredAt"
                data-cy="delveredAt"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mealPlan.consumedAt')}
                id="meal-plan-consumedAt"
                name="consumedAt"
                data-cy="consumedAt"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mealPlan.instructions')}
                id="meal-plan-instructions"
                name="instructions"
                data-cy="instructions"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mealPlan.status')}
                id="meal-plan-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {mealStatusValues.map(mealStatus => (
                  <option value={mealStatus} key={mealStatus}>
                    {translate(`tinyMedicRestApp.MealStatus.${mealStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="meal-plan-nutritionPlan"
                name="nutritionPlan"
                data-cy="nutritionPlan"
                label={translate('tinyMedicRestApp.mealPlan.nutritionPlan')}
                type="select"
              >
                <option value="" key="0" />
                {nutritionPlanIPS
                  ? nutritionPlanIPS.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="meal-plan-treatmentPlan"
                name="treatmentPlan"
                data-cy="treatmentPlan"
                label={translate('tinyMedicRestApp.mealPlan.treatmentPlan')}
                type="select"
                required
              >
                <option value="" key="0" />
                {treatmentPlans
                  ? treatmentPlans.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="meal-plan-nutritionOrder"
                name="nutritionOrder"
                data-cy="nutritionOrder"
                label={translate('tinyMedicRestApp.mealPlan.nutritionOrder')}
                type="select"
              >
                <option value="" key="0" />
                {nutritionOrders
                  ? nutritionOrders.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/meal-plan" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MealPlanUpdate;
